import { render, staticRenderFns } from "./HomeBoxAscentsLog.vue?vue&type=template&id=fa70a89e"
import script from "./HomeBoxAscentsLog.vue?vue&type=script&lang=js"
export * from "./HomeBoxAscentsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports